import { ReactElement } from 'react'

import Typography from 'shared-components/typography'

export default function NotFound(): ReactElement {
	return (
		<Typography variant="h4">
			Not found
		</Typography>
	)
}
